<button
  (click)="clearFilters()"
  class="mb-1.5 ml-1.5 cursor-pointer text-[#e80013] font-medium"
>
  Clear Filters
</button>
<div class="rounded-[20px] border border-[#eaeaea] filter_card">
  <button
    (click)="toggleFilterCard()"
    class="block lg:hidden w-full bg-[#6c7884] text-center mb-[-5px] text-[#fff] py-3 touch-manipulation cursor-pointer relative overflow-hidden rounded-[.5rem] border-none outline-none"
  >
    Filter Results
  </button>
  <div
    [ngClass]="{
      hidden: !isFilterCardVisible,
      block: isFilterCardVisible,
      'lg:block': true,
    }"
    class="container relative"
  >
    <div class="flex flex-wrap items-center text-left">
      <div class="basis-[100%]">
        <ul class="py-3">
          <li class="border-b py-3 px-5">
            <out-detail title="Seller Type" [open]="false">
              <div class="">
                <div>
                  <label>
                    <input
                      type="radio"
                      [name]="'dealer'"
                      [value]="'dealer'"
                      [checked]="getControl('dealer').value === 'ALL_OPTIONS'"
                      (change)="onControlChange('dealer', 'ALL_OPTIONS')"
                    />
                    All
                  </label>
                </div>
                <div>
                  <label>
                    <input
                      type="radio"
                      [name]="'dealer'"
                      [value]="'dealer'"
                      [checked]="
                        getControl('dealer').value === 'Individual Seller'
                      "
                      (change)="onControlChange('dealer', 'Individual Seller')"
                    />
                    Private Seller
                  </label>
                </div>
                <div>
                  <label>
                    <input
                      type="radio"
                      [name]="'dealer'"
                      [value]="'dealer'"
                      [checked]="
                        getControl('dealer').value === '!Individual Seller'
                      "
                      (change)="onControlChange('dealer', '!Individual Seller')"
                    />
                    Dealer
                  </label>
                </div>
              </div>
            </out-detail>
          </li>
          <li class="border-b py-3 px-5">
            <out-detail title="Model">
              <div class="">
                <div *ngFor="let item of options.model">
                  <label>
                    <input
                      type="radio"
                      [name]="'model'"
                      [value]="item.value"
                      [checked]="getControl('model').value === item.value"
                      (change)="onControlChange('model', item.value)"
                    />
                    {{ item.label }}
                  </label>
                </div>
              </div>
            </out-detail>
          </li>
          <li class="border-b py-3 px-5 last:border-b-0 last:pb-0">
            <out-detail title="Year">
              <div class="">
                <input
                  *ngIf="options.year.length > 8"
                  type="text"
                  [(ngModel)]="searchTerms['year']"
                  placeholder="Search..."
                  class="w-full p-2 mb-2 border rounded-lg shadow-sm focus:ring-0 focus:outline-none"
                />
                <div
                  [ngClass]="[
                    options.year.length > 8
                      ? 'rounded-lg border mb-3 p-2 max-h-[205px] overflow-y-auto shadow-sm'
                      : ''
                  ]"
                >
                  <div *ngFor="let item of filteredOptions('year')">
                    <label>
                      <input
                        type="radio"
                        [name]="'year'"
                        [value]="item.value"
                        [checked]="getControl('year').value === item.value"
                        (change)="onControlChange('year', item.value)"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>
              </div>
            </out-detail>
          </li>
          <li class="border-b py-3 px-5 last:border-b-0 last:pb-0">
            <out-detail title="Listing Type">
              <div class="">
                <input
                  *ngIf="options.listingType.length > 8"
                  type="text"
                  [(ngModel)]="searchTerms['listingType']"
                  placeholder="Search..."
                  class="w-full p-2 mb-2 border rounded-lg shadow-sm focus:ring-0 focus:outline-none"
                />
                <div
                  [ngClass]="[
                    options.listingType.length > 8
                      ? 'rounded-lg border mb-3 p-2 max-h-[205px] overflow-y-auto shadow-sm'
                      : ''
                  ]"
                >
                  <div *ngFor="let item of filteredOptions('listingType')">
                    <label>
                      <input
                        type="radio"
                        [name]="'listingType'"
                        [value]="item.value"
                        [checked]="
                          getControl('listingType').value === item.value
                        "
                        (change)="onControlChange('listingType', item.value)"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>
              </div>
            </out-detail>
          </li>
          <li class="border-b py-3 px-5 last:border-b-0 last:pb-0">
            <out-detail title="Condition">
              <div class="">
                <input
                  *ngIf="options.condition.length > 8"
                  type="text"
                  [(ngModel)]="searchTerms['condition']"
                  placeholder="Search..."
                  class="w-full p-2 mb-2 border rounded-lg shadow-sm focus:ring-0 focus:outline-none"
                />
                <div
                  [ngClass]="[
                    options.condition.length > 8
                      ? 'rounded-lg border mb-3 p-2 max-h-[205px] overflow-y-auto shadow-sm'
                      : ''
                  ]"
                >
                  <div *ngFor="let item of filteredOptions('condition')">
                    <label>
                      <input
                        type="radio"
                        [name]="'condition'"
                        [value]="item.value"
                        [checked]="getControl('condition').value === item.value"
                        (change)="onControlChange('condition', item.value)"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>
              </div>
            </out-detail>
          </li>
          <li class="border-b py-3 px-5 last:border-b-0 last:pb-0">
            <out-detail title="Autopilot">
              <div class="">
                <input
                  *ngIf="options.autopilot.length > 8"
                  type="text"
                  [(ngModel)]="searchTerms['autopilot']"
                  placeholder="Search..."
                  class="w-full p-2 mb-2 border rounded-lg shadow-sm focus:ring-0 focus:outline-none"
                />
                <div
                  [ngClass]="[
                    options.autopilot.length > 8
                      ? 'rounded-lg border mb-3 p-2 max-h-[205px] overflow-y-auto shadow-sm'
                      : ''
                  ]"
                >
                  <div *ngFor="let item of filteredOptions('autopilot')">
                    <label>
                      <input
                        type="radio"
                        [name]="'autopilot'"
                        [value]="item.value"
                        [checked]="getControl('autopilot').value === item.value"
                        (change)="onControlChange('autopilot', item.value)"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>
              </div>
            </out-detail>
          </li>
          <li class="border-b py-3 px-5 last:border-b-0 last:pb-0">
            <out-detail title="Trim">
              <div class="">
                <input
                  *ngIf="options.trim.length > 8"
                  type="text"
                  [(ngModel)]="searchTerms['trim']"
                  placeholder="Search..."
                  class="w-full p-2 mb-2 border rounded-lg shadow-sm focus:ring-0 focus:outline-none"
                />
                <div
                  [ngClass]="[
                    options.trim.length > 8
                      ? 'rounded-lg border mb-3 p-2 max-h-[205px] overflow-y-auto shadow-sm'
                      : ''
                  ]"
                >
                  <div *ngFor="let item of filteredOptions('trim')">
                    <label>
                      <input
                        type="radio"
                        [name]="'trim'"
                        [value]="item.value"
                        [checked]="getControl('trim').value === item.value"
                        (change)="onControlChange('trim', item.value)"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>
              </div>
            </out-detail>
          </li>
          <li class="border-b py-3 px-5 last:border-b-0 last:pb-0">
            <out-detail title="Location">
              <input
                *ngIf="options.location.length > 8"
                type="text"
                [(ngModel)]="searchTerms['location']"
                placeholder="Search..."
                class="w-full p-2 mb-2 border rounded-lg shadow-sm focus:ring-0 focus:outline-none"
              />
              <div
                [ngClass]="[
                  options.location.length > 8
                    ? 'rounded-lg border mb-3 p-2 max-h-[205px] overflow-y-auto shadow-sm'
                    : ''
                ]"
              >
                <div *ngFor="let item of filteredOptions('location')">
                  <label>
                    <input
                      type="radio"
                      [name]="'location'"
                      [value]="item.value"
                      [checked]="getControl('location').value === item.value"
                      (change)="onControlChange('location', item.value)"
                    />
                    {{ item.label }}
                  </label>
                </div>
              </div>
            </out-detail>
          </li>
        </ul>
      </div>
      <!-- <div *ngIf="load === 'skeleton'" class="basis-[100%] h-[300px]"></div> -->
    </div>
  </div>
</div>
